export default class {
  constructor() {
    this.options = {
      el: '.js-map-content',
      dom: {
        // put here all block's dom elements
        title: '[data-block-title]',
        img: '[data-block-img]'
      },
      classes: {
        // put all class names here
        titleXl: 'title--xl'
      }
    };
      this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
      this.$window = $(window);
      this.$document = $(document);
      this.$body = $('body');
      this.height = this.$el.height();
      this.width = this.$el.width();
      this.minZoom = 0;
      this.maxZoom = 1;
      this.curZoom = 1;
      this.transformX = 0;
      this.transformY = 0;
      this.isMove = false;
      this.maxX = this.$window.width() - this.width * this.curZoom;
      this.maxY = this.$window.height() - this.height * this.curZoom;

    return this;
  }

  /*** Выбираем минимально допустимый зум, уменьшаем страницу и располагаем по центру ***/
  setZoom() {

    const coefficientVert = this.$window.height() / this.height;
    const coefficientHor = this.$window.width() / this.width;

    let minZoom = Math.max(coefficientHor, coefficientVert);

    if (this.$window.width() > 1023) {
      minZoom = Math.max(0.4, minZoom);
    }

    let transformX = (this.$window.width() - this.width * minZoom) / 2;
    let transformY = (this.$window.height() - this.height * minZoom) / 2;

    this.transformX = transformX;
    this.transformY = transformY;

    this.$el.css({
      transform: `matrix(${minZoom}, 0, 0, ${minZoom}, ${transformX}, ${transformY})`
    });

    $('.js-zoom-out').addClass('disabled');

    return minZoom;
  }
  setMax() {
    this.maxX = this.$window.width() - this.width * this.curZoom;
    this.maxY = this.$window.height() - this.height * this.curZoom;
  }
  /***  ***/
  setZoomIn (x= this.$window.width()/2, y = this.$window.height()/2) {

    $('.js-zoom-out').removeClass('disabled');

    let curZoom = this.curZoom;
    const maxZoom = this.maxZoom;

    let step = 1.25;
    let $el = $(this.$el);
    let $this = this;
    if (curZoom * step >= maxZoom) {
      step = 1;
      $('.js-zoom-in').addClass('disabled');
    }

    let current = {x: $this.transformX, y: $this.transformY, zoom: curZoom},
      oz = current.zoom,
      nz = current.zoom * step,
      /// calculate click at current zoom
      ix = (x - current.x) / oz,
      iy = (y - current.y) / oz,
      /// calculate click at new zoom
      nx = ix * nz,
      ny = iy * nz,
      /// move to the difference
      /// make sure we take mouse pointer offset into account!
      cx = x - nx,
      cy = y - ny
    ;

    $this.curZoom = nz;
    $this.setMax();

    let transformX, transformY;
    transformX = x - nx;
    transformY = y - ny;

    transformX = Math.min(0, transformX);
    transformX = Math.max($this.maxX, transformX);

    transformY = Math.min(0, transformY);
    transformY = Math.max($this.maxY, transformY);

    // update current
    current.zoom = nz;
    current.x = transformX;
    current.y = transformY;
    $this.transformX = transformX;
    $this.transformY = transformY;
    /// make sure we translate before scale!
    $el.addClass('animation');
    $el.css({
      transform: `matrix(${nz}, 0, 0, ${nz}, ${transformX}, ${transformY})`
    });
    setTimeout(function () {
      $el.removeClass('animation');
    }, 500);
  }
  setZoomOut (x= this.$window.width()/2, y = this.$window.height()/2) {

    $('.js-zoom-in').removeClass('disabled');

    let curZoom = this.curZoom;
    const minZoom = this.minZoom;

    let step = 0.8;
    let $el = $(this.$el);
    let $this = this;
    if (curZoom * step <= minZoom) {
      step = 1;
      $('.js-zoom-out').addClass('disabled');
    }

    let current = {x: $this.transformX, y: $this.transformY, zoom: curZoom},
      oz = current.zoom,
      nz = current.zoom * step,
      /// calculate click at current zoom
      ix = (x - current.x) / oz,
      iy = (y - current.y) / oz,
      /// calculate click at new zoom
      nx = ix * nz,
      ny = iy * nz,
      /// move to the difference
      /// make sure we take mouse pointer offset into account!
      cx = x - nx,
      cy = y - ny
    ;

    $this.curZoom = nz;
    $this.setMax();

    let transformX, transformY;
    transformX = x - nx;
    if (transformX > 0) {
      transformX = 0
    } else {
      if (transformX < $this.maxX) {
        transformX = $this.maxX
      }
    }
    transformY = y - ny;
    if (transformY > 0) {
      transformY = 0
    } else {
      if (transformY < $this.maxY) {
        transformY = $this.maxY
      }
    }

    // update current
    current.zoom = nz;
    current.x = transformX;
    current.y = transformY;
    $this.transformX = transformX;
    $this.transformY = transformY;
    /// make sure we translate before scale!
    $el.addClass('animation');
    $el.css({
      transform: `matrix(${nz}, 0, 0, ${nz}, ${transformX}, ${transformY})`
    });
    setTimeout(function () {
      $el.removeClass('animation');
    }, 500);
  }
  setZoomInOnWheel (x= this.$window.width()/2, y = this.$window.height()/2) {

    $('.js-zoom-out').removeClass('disabled');

    let curZoom = this.curZoom;
    const maxZoom = this.maxZoom;

    let step = 1.15;
    if (this.$window.width() < 1025) {
      step = 1.005;
    }
    let $el = $(this.$el);
    let $this = this;

    if (curZoom * step >= maxZoom) {
      step = 1;
      $('.js-zoom-in').addClass('disabled');
    }

    let current = {x: $this.transformX, y: $this.transformY, zoom: curZoom},
      oz = current.zoom,
      nz = current.zoom * step,
      /// calculate click at current zoom
      ix = (x - current.x) / oz,
      iy = (y - current.y) / oz,
      /// calculate click at new zoom
      nx = ix * nz,
      ny = iy * nz,
      /// move to the difference
      /// make sure we take mouse pointer offset into account!
      cx = x - nx,
      cy = y - ny
    ;

    $this.curZoom = nz;
    $this.setMax();

    let transformX, transformY;
    transformX = cx;
    transformY = cy;

    transformX = Math.min(0, transformX);
    transformX = Math.max($this.maxX, transformX);

    transformY = Math.min(0, transformY);
    transformY = Math.max($this.maxY, transformY);

    // update current
    current.zoom = nz;
    current.x = transformX;
    current.y = transformY;
    $this.transformX = transformX;
    $this.transformY = transformY;
    $el.css({
      transform: `matrix(${nz}, 0, 0, ${nz}, ${transformX}, ${transformY})`
    });
  }
  setZoomOutOnWheel (x= this.$window.width()/2, y = this.$window.height()/2) {

    $('.js-zoom-in').removeClass('disabled');

    let curZoom = this.curZoom;
    const minZoom = this.minZoom;

    let step = 0.9;
    if (this.$window.width() < 1025) {
      step = 0.955;
    }
    let $el = $(this.$el);
    let $this = this;

    if (curZoom * step <= minZoom) {
      step = 1;
      $('.js-zoom-out').addClass('disabled');
    }

    let current = {x: $this.transformX, y: $this.transformY, zoom: curZoom},
      oz = current.zoom,
      nz = current.zoom * step,
      /// calculate click at current zoom
      ix = (x - current.x) / oz,
      iy = (y - current.y) / oz,
      /// calculate click at new zoom
      nx = ix * nz,
      ny = iy * nz,
      /// move to the difference
      /// make sure we take mouse pointer offset into account!
      cx = x - nx,
      cy = y - ny
    ;

    $this.curZoom = nz;
    $this.setMax();

    let transformX, transformY;
    transformX = x - nx;
    transformY = y - ny;

    transformX = Math.min(0, transformX);
    transformX = Math.max($this.maxX, transformX);

    transformY = Math.min(0, transformY);
    transformY = Math.max($this.maxY, transformY);

    // update current
    current.zoom = nz;
    current.x = transformX;
    current.y = transformY;
    $this.transformX = transformX;
    $this.transformY = transformY;

    $el.css({
      transform: `matrix(${nz}, 0, 0, ${nz}, ${transformX}, ${transformY})`
    });
  }

  setFocus(x,y) {
    let $el = $(this.$el);
    let $this = this;
    let offset = $el.offset();
    const maxZoom = $this.maxZoom;
    const curZoom = $this.curZoom;

    /*** Находим расстояние от центра до края ***/
    let center = {
      x: this.$window.width() / 2,
      y: this.$window.height() / 2
    }
    let curX = center.x + offset.left;
    let curY = center.y + offset.top;

    /*** Определяем, в какую сторону нужно сдвигать точку ***/
    let shiftX = center.x - x;
    let shiftY = center.y - y;

    let transformX, transformY;

    transformX = offset.left + shiftX;
    transformY = offset.top + shiftY;

    transformX = Math.min(0, transformX);
    transformX = Math.max($this.maxX, transformX);

    transformY = Math.min(0, transformY);
    transformY = Math.max($this.maxY, transformY);

    $this.transformX = transformX;
    $this.transformY = transformY;

    $el.addClass('animation');
    $el.css({
      transform: `matrix(${curZoom}, 0, 0, ${curZoom}, ${transformX}, ${transformY})`
    });
    setTimeout(function () {
      $el.removeClass('animation');
      $this.curZoom = $this.maxZoom;
      $this.setMax();
    }, 300);
  }

  get() {
    this.$el = $(this.$el);

    return this;
  }

  init() {
    let $this = this;
    let $el = $(this.$el);
    window.onpageshow = function () {
      $this.minZoom = $this.setZoom();
      $this.curZoom = $this.minZoom;
      $this.setMax();
    };
    $this.$window.on('resize', ()=>{
      $this.minZoom = $this.setZoom();
      $this.curZoom = $this.minZoom;
      $this.setMax();
    });
    $this.$document.ready(() => {

      $this.$document.on('click', '.js-result', function () {
        $('.map-search').removeClass('active');
        $('.search-results').removeClass('active');
        setTimeout(function () {
          $('.js-search-open').addClass('active');
          $('#search').val('');
          $('#searchMobile').val('');
          $('.search-results__wrap').html('');
          $('.mobile-search__results').html('');
        },310);
        let id = $(this).attr('data-filter-id');

        const curEl = document.querySelector('g[data-id="' + id + '"]');
        $this.curZoom = $this.maxZoom;
        $this.setMax();
        $this.setZoomInOnWheel();
        $this.setFocus(curEl.getBoundingClientRect().left, curEl.getBoundingClientRect().top);
        $('.map-link[data-id="' + id + '"]').addClass('active');
        setTimeout(function () {
          $('.map-link[data-id="' + id + '"]').removeClass('active');
        },5000);
      });
      /*$this.$el.bind('onwheel', function(e){

        if(e.originalEvent.wheelDelta /120 > 0) {
          if (!$this.isMove) {
            $this.setZoomInOnWheel(e.clientX, e.clientY);
          }
        }
        else {
          if (!$this.isMove) {
            $this.setZoomOutOnWheel(e.clientX, e.clientY);
          }
        }
      }); */
      $this.$el.bind('dblclick', function(e){
        e.preventDefault();
        if (!$this.isMove) {
          $this.setZoomIn(e.clientX, e.clientY);
        }
      });
      $('.js-zoom-in').on('click', function () {
        if (!$this.isMove) {
          $this.setZoomIn();
        }
      });
      $('.js-zoom-out').on('click', function () {
        if (!$this.isMove) {
          $this.setZoomOut();
        }
      });

      const map = document.getElementById('mapContent');
      const link = $('.map__link');

      let initialPoint, initialPointX, initialPointY;
      let finalPoint, finalPointX, finalPointY;

      let curX, curY;

      let scaling = false;
      let initialDist, finalDist, dist;

      let tapedTwiceMap = false;
      let xCenter, yCenter;

      let targetTouchesLength = 0;

      function distance (p1, p2) {
        return (Math.sqrt(Math.pow((p1.clientX - p2.clientX), 2) + Math.pow((p1.clientY - p2.clientY), 2)));
      }

      map.addEventListener('mousedown', function(event) {
        curX = $this.transformX;
        curY = $this.transformY;

        if (link.has(event.target).length === 0) {
          initialPointX = event.pageX;
          initialPointY = event.pageY;
          $this.isMove = true;
          $el.addClass('moving');
        }
      }, false);
      map.addEventListener('mousemove', function(event) {
        finalPointX = event.pageX;
        finalPointY = event.pageY;
        let xAbs = Math.abs(initialPointX - finalPointX);
        let yAbs = Math.abs(initialPointY - finalPointY);

        if ($this.isMove) {
          if (xAbs > 5 || yAbs > 5) {
            let stepX = initialPointX -finalPointX;
            let stepY = initialPointY -finalPointY;
            let resultX = curX - stepX / $this.curZoom;
            let resultY = curY - stepY / $this.curZoom;

            resultX = Math.min(0, resultX);
            resultX = Math.max($this.maxX, resultX);

            resultY = Math.min(0, resultY);
            resultY = Math.max($this.maxY, resultY);

            $this.transformX = resultX;
            $this.transformY = resultY;

            let nz = $this.curZoom;

            $el.css({
              transform: `matrix(${nz}, 0, 0, ${nz}, ${resultX}, ${resultY})`
            });
          }
        }
      }, false);
      map.addEventListener('mouseup', function(event) {
        $this.isMove = false;
        $el.removeClass('moving');
      }, false);
      map.addEventListener('touchstart', function(event) {
        let offset = $el.offset();
        curX = offset.left;
        curY = offset.top;

        let targetTouches = event.targetTouches;
        targetTouchesLength = targetTouches.length;
        if (targetTouches && targetTouches.length >= 2) {
          event.preventDefault();
          initialDist = distance(targetTouches[0], targetTouches[1]);
          $('#console').append('initialDist ' + initialDist);
          scaling = true;
          let x1 = event.touches[0].clientX;
          let y1 = event.touches[0].clientY;
          let x2 = event.touches[1].clientX;
          let y2 = event.touches[1].clientY;
          xCenter = (x1 + x2)/2;
          yCenter = (y1 + y2)/2;
          $el.removeClass('moving');
        } else {
          scaling = false;
          initialPoint=event.changedTouches[0];
          $el.addClass('moving');
        }
        if(!tapedTwiceMap) {
          tapedTwiceMap = true;
          setTimeout( function() { tapedTwiceMap = false; }, 300 );
          return false;
        } else {
          event.preventDefault();
          let x = event.touches[0].clientX;
          let y = event.touches[0].clientY;
          $this.setZoomIn(x, y);
          $el.removeClass('moving');

        }
      }, false);
      map.addEventListener('touchmove', function(event) {

        let targetTouches = event.targetTouches;
        if (scaling) {
          //e.preventDefault();
          finalDist = distance(targetTouches[0], targetTouches[1]);
          $('#console').text('initialDist' + initialDist + 'finalDist ' + finalDist);

          dist = finalDist - initialDist;
          if (dist > 0) {
            $this.setZoomInOnWheel(xCenter,yCenter);
          } else {
            $this.setZoomOutOnWheel(xCenter,yCenter);
          }
        } else if (!scaling && targetTouchesLength === 1) {
          finalPoint = event.changedTouches[0];

          const deltaX = initialPoint.pageX - finalPoint.pageX;
          const deltaY = initialPoint.pageY - finalPoint.pageY;

          let resultX = curX - deltaX;
          let resultY = curY - deltaY;

          resultX = Math.min(0, resultX);
          resultX = Math.max($this.maxX, resultX);

          resultY = Math.min(0, resultY);
          resultY = Math.max($this.maxY, resultY);

          $this.transformX = resultX;
          $this.transformY = resultY;

          $el.css({
            transform: `matrix(${$this.curZoom}, 0, 0, ${$this.curZoom}, ${resultX}, ${resultY})`
          });
        }
      }, false);
      map.addEventListener('touchend', function(event) {
        let targetTouches = event.targetTouches;
        scaling = false;
        if (targetTouches.length < 2) {
          scaling = false;
        } else {
          //scaling = true;
        }
        $el.removeClass('moving');
      }, false);
      map.addEventListener('mouseleave', function(event) {
        $this.isMove = false;
        $el.removeClass('moving');
      }, false);
      //map.addEventListener('DOMMouseScroll', mousewheel, false);
      map.onwheel = function(e) {
        if(e.deltaY > 0) {
          if (!$this.isMove) {
            $this.setZoomInOnWheel(e.clientX, e.clientY);
          }
        }
        else {
          if (!$this.isMove) {
            $this.setZoomOutOnWheel(e.clientX, e.clientY);
          }
        }
        return false;
      }
    });
  }

  render() {
    if (this.$el.length) {
      // do pre-initialisation stuff here
      this
        .get()
        .init()
    }
  }
}
